import { render, staticRenderFns } from "./RelationsList.vue?vue&type=template&id=658d694d&"
import script from "./RelationsList.vue?vue&type=script&lang=js&"
export * from "./RelationsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports